import { createLanguageList } from "./languages-summary.utilities";
import { Fragment, FunctionComponent, memo, useMemo } from "react";
import { IProps } from "./languages-summary.types";
import "./languages-summary.scss";

/**
 * Create a list of language names using the ISO codes passed.
 * @param languageIsoCodes List of languages passed as ISO codes.
 * @param languages        All languages with details.
 */
const LanguagesSummary: FunctionComponent<IProps> = ({ languageIsoCodes = [], languages }) => {
    const summary = createLanguageList(languageIsoCodes, languages);
    return <Fragment>{summary}</Fragment>;
};

export default memo(LanguagesSummary);
